﻿<template>
  <div data-page-type="no-header">
    <Form as="div" ref="form">
      <div id="studyflow" data-page-type="flow">
        <div class="container">
          <header class="header-static">
            <a :href="vueModel.Content.Shared.LinkClose.Url" class="close-button open-modal">
              <span class="icon icon-close" />
            </a>
          </header>
        </div>
        <page-spinner :spinner-url-list="spinnerUrlList" />
        <div id="mainView" class="flow__body no-footer row container">
          <div class="small-12 medium-12 large-6 columns">
            <keep-alive>
              <transition name="fade" mode="out-in">
                <component
                  :is="currentTemplate"
                  ref="studyFlow"
                  :key="index"
                  v-model="studyModel"
                  :local-model="localModel"
                  :content="content"
                  :name="'main-view'"
                  @showstderrormodal="showModalError"
                  @showstdcontactmodal="showModalContact"
                  @showstdstopmodal="showModalStop"
                  @zipchange="updateZip"
                  @studyextrachange="updateIsStudyExtra"
                />
              </transition>
            </keep-alive>

            <div v-cloak class="row push-down">
              <div class="columns">
                <a
                  class="button large"
                  data-test="study-submit-button"
                  :class="{ hide: index !== 5 }"
                  @click="submit"
                  v-html="vueModel.Content.StepFive.LabelConfirmPurchase"
                />
              </div>

              <div class="columns">
                <button
                  class="button"
                  data-test="study-next-button"
                  :class="{ hide: index >= 5 }"
                  :disabled="submitIsBlocked"
                  @click="next"
                  v-html="vueModel.Content.Shared.LabelNext"
                />
              </div>
            </div>
            <div
              v-cloak
              :class="{ hide: index !== 5 }"
              v-html="vueModel.Content.StepFive.LabelExtraInformation"
            />
            <a
              v-cloak
              v-if="!submitIsBlocked"
              :class="{ hide: index === 1 || index === 6 }"
              @click="index -= 1"
            >
              &lt; Tilbage
            </a>
          </div>
          <div v-cloak class="small-12 medium-12 large-6 columns">
            <sticky-basket
              :name="name"
              :price="totalPrice"
              :class="{ 'fade-enter': !totalPrice, 'fade-enter-active': totalPrice }"
            >
              <template #label-mobile>
                <span v-html="vueModel.Content.Shared.LabelTotalPrice" />
              </template>
              <template #label>
                <span v-html="vueModel.Content.Shared.LabelTotalPrice" />
              </template>
            </sticky-basket>
            <div class="row">
              <div class="small-12 medium-12 large-10 large-offset-2 columns">
                <div class="callout">
                  <div>
                    <div>
                      <h3 v-html="vueModel.Content.Shared.LabelContentInsuranceBoxTitle" />
                      <div
                        v-if="!studyInsuranceSubmitTemplate.IsStudyExtra"
                        v-html="vueModel.Content.Shared.LabelStudyContentInsuranceBoxBody"
                      />

                      <div
                        v-if="studyInsuranceSubmitTemplate.IsStudyExtra"
                        v-html="vueModel.Content.Shared.LabelStudyExtraContentInsuranceBoxBody"
                      />
                    </div>
                    <div>
                      <h3 v-html="vueModel.Content.Shared.LabelAccidentInsuranceBoxTitle" />
                      <div
                        v-if="!studyInsuranceSubmitTemplate.IsStudyExtra"
                        v-html="vueModel.Content.Shared.LabelStudyAccidentInsuranceBoxBody"
                      />
                      <div
                        v-if="studyInsuranceSubmitTemplate.IsStudyExtra"
                        v-html="vueModel.Content.Shared.LabelStudyExtraAccidentInsuranceBoxBody"
                      />
                    </div>
                  </div>
                </div>
                <div class="callout">
                  <ul class="accordion">
                    <li class="accordion-item">
                      <div class="row">
                        <div class="columns padding-bottom">
                          <div
                            class="accordion-title h3 no-border-top no-padding"
                            v-html="vueModel.Content.Shared.LabelInsuranceTermsTitle"
                          />
                          <div
                            v-for="(pdf, index) in vueModel.Content.Shared.LabelInsuranceTermsPDFs"
                            :key="index"
                            class="accordion-content no-border-top no-padding"
                          >
                            <p>
                              <i class="icon-download" />&nbsp;
                              <a :href="pdf.Url" target="_blank" v-html="pdf.Text" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="accordion-item">
                      <div class="row">
                        <div class="columns">
                          <div
                            class="accordion-title h3 no-border-top no-padding"
                            v-html="vueModel.Content.Shared.LabelProductInformationDocumentTitle"
                          />
                          <div
                            v-for="(pdf, index) in vueModel.Content.Shared
                              .LabelProductInformationDocumentPDFs"
                            :key="index"
                            class="accordion-content no-border-top no-padding"
                          >
                            <p>
                              <i class="icon-download" />&nbsp;
                              <a :href="pdf.Url" target="_blank" v-html="pdf.Text" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <progress-bar
          v-if="index < 6"
          :flow-index="index"
          :pills="[
            { title: vueModel.Content.StepOne.LabelSectionTitle },
            { title: vueModel.Content.StepTwo.LabelSectionTitle },
            { title: vueModel.Content.StepThree.Title },
            { title: 'Tidligere skader' },
            { title: vueModel.Content.StepFive.LabelSectionTitle }
          ]"
          :title="title"
        />
      </div>
      <transition v-cloak name="modal">
        <v-modal :is-open="showStudyModal" @close="closeModal">
          <template #title>
            <div>
              <h3
                v-if="showStudyModalStop"
                v-html="vueModel.Content.Shared.LabelStopFlowModalTitle"
              />
              <h3
                v-if="showStudyModalContact"
                v-html="vueModel.Content.Shared.LabelTerminationStopFlowModalTitle"
              />
              <h3
                v-if="showStudyModalError"
                v-html="vueModel.Content.Shared.LabelGenericStopFlowModalTitle"
              />
            </div>
          </template>

          <template #content>
            <p
              v-if="showStudyModalStop"
              v-html="vueModel.Content.Shared.LabelStopFlowModalBody"
            />
            <p
              v-if="showStudyModalContact"
              v-html="vueModel.Content.Shared.LabelTerminationStopFlowModalBody"
            />
            <p
              v-if="showStudyModalError"
              v-html="vueModel.Content.Shared.LabelGenericStopFlowModalBody"
            />
          </template>
          <template #footer>
            <div>
              <button
                class="button"
                @click="closeModal"
                v-html="vueModel.Content.Shared.LabelClose"
              />
            </div>
          </template>
        </v-modal>
      </transition>
    </Form>
  </div>
</template>

<script>
import AdditionalInfoStudyVue from '@/components/Feature/Study/AdditionalInfoStudy.vue';
import BasicInfoStudyVue from '@/components/Feature/Study/BasicInfoStudy.vue';
import ClaimsStudy from '@/components/Feature/Study/ClaimsStudy.vue';
import PaymentInfoStudyVue from '@/components/Feature/Study/PaymentInfoStudy.vue';
import PersonalInfoStudyVue from '@/components/Feature/Study/PersonalInfoStudy.vue';
import RecieptStudyVue from '@/components/Feature/Study/ReceiptStudy.vue';
import StudyMixin from './StudyMixin.vue';
import ProgressBar from '@/components/UI/ProgressBar.vue';
import ValidatePropsMixin from '@/components/Feature/ValidatePropsMixin.vue';
import Utility from '@/common/UtilityFunctions.js';

import axios from 'axios';
import StickyBasket from '@/common/FlowBasket.vue';

import PageSpinner from '@/components/UI/PageSpinner.vue';

export default {
  name: 'StudyFlow',
  components: {
    ProgressBar,
    'step1-template': BasicInfoStudyVue,
    'step2-template': PersonalInfoStudyVue,
    'step3-template': AdditionalInfoStudyVue,
    'step4-template': ClaimsStudy,
    'step5-template': PaymentInfoStudyVue,
    'step6-template': RecieptStudyVue,
    PageSpinner,
    StickyBasket
  },
  mixins: [ValidatePropsMixin, StudyMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      studyModel: {},
      studyInsuranceSubmitTemplate: {},
      localModel: {
        studentMemberOrganization: null,
        cpr: {
          date: null,
          control: null
        },
        currentDate: new Date(),
        address: {
          adresse: {
            postnrnavn: null
          }
        },
        expectedFinishingDate: null,
        insuranceStartDate: null,
        initStep: {}
      },
      index: 1,
      name: 'studyFlow',
      showStudyModal: false,
      showStudyModalError: false,
      showStudyModalContact: false,
      showStudyModalStop: false,
      isSticky: false,
      loading: false,
      totalPrice: null,
      content: {}
    };
  },
  computed: {
    currentTemplate() {
      if (this.index <= 6) {
        return 'step' + this.index + '-template';
      }
      return 'step' + 1 + '-template';
    },
    title() {
      if (
        this.vueModel &&
        !this.studyInsuranceSubmitTemplate.IsStudyExtra &&
        this.content.Shared?.LabelStudyInsurance
      ) {
        return this.content.Shared.LabelStudyInsurance;
      }
      return this.content.Shared?.LabelStudyExtraInsurance ?? '';
    },
    spinnerUrlList() {
      return [Utility.constants().API.quickquote_study_submit];
    },
    submitIsBlocked() {
      return (
        this.studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate === 2 ||
        this.studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate === 2 ||
        this.studyInsuranceSubmitTemplate.NumberOfClaims === 4 ||
        this.studyInsuranceSubmitTemplate.NumberOfTheftClaims === 3 ||
        this.studyInsuranceSubmitTemplate.NumberOfBikeTheftClaims === 3 ||
        this.studyInsuranceSubmitTemplate.NumberOfAccidentClaims === 4 ||
        this.studyInsuranceSubmitTemplate.PreviousCompanyDisclaimerOption === 'Ja'
      );
    }
  },
  watch: {
    'studyInsuranceSubmitTemplate.Zip': function (val) {
      const self = this;
      if (val) {
        this.$refs.form.validateField('PostalCode').then((result) => {
          if (result.valid) {
            this.totalPrice = null;
            self.getPrice();
          }
        });
      }
    },
    'studyInsuranceSubmitTemplate.Content_HasInsuranceToTerminate': function (val) {
      if (val === 2) {
        this.showModalContact();
      }
    },
    'studyInsuranceSubmitTemplate.Accident_HasInsuranceToTerminate': function (val) {
      if (val === 2) {
        this.showModalContact();
      }
    }
  },
  mounted() {
    this.studyModel = this.vueModel;
    this.studyInsuranceSubmitTemplate = this.vueModel.Data.StudyInsuranceSubmitTemplate;
    this.content = this.vueModel.Content;
  },
  updated() {
    if (this.index != 0 && this.isSticky == false) {
      this.isSticky = true;
      Utility.stickyBasket();
    }
  },
  methods: {
    next() {
      this.$refs.form.validate().then((result) => {
        if (result.valid) {
          this.pushToTagManagerOnNext();
          if (this.index < 6) {
            this.index += 1;
          }
        } else {
          this.$refs.studyFlow.scrollToFirstError();
        }
      });
    },
    getPrice() {
      this.vueModel.Data.StudyInsuranceCalculationTemplate = {
        Zipcode: this.studyInsuranceSubmitTemplate.Zip,
        IsStudyExtra: this.studyInsuranceSubmitTemplate.IsStudyExtra,
        DatasourceId: this.studyInsuranceSubmitTemplate.DatasourceId
      };

      const self = this;
      axios
        .post(
          Utility.constants().API.quickquote_study_calculate,
          this.vueModel.Data.StudyInsuranceCalculationTemplate
        )
        .then((response) => {
          if (response.data.Error === '') {
            self.totalPrice =
              response.data.Price + ' ' + this.vueModel.Content.Shared.LabelCurrency;
          } else {
            this.showStudyModalError = true;
          }
        })
        .catch((err) => {
          Utility.logError(err.message, this);
          this.pushToTagManagerOnError(err.message);
        });
    },
    updateZip(val) {
      this.studyInsuranceSubmitTemplate.Zip = val;
      if (val.length == 4) {
        this.getPrice();
      }
    },
    updateIsStudyExtra(val) {
      this.studyInsuranceSubmitTemplate.IsStudyExtra = val;
      this.getPrice();
    },
    submit() {
      const self = this;
      this.$refs.form.validate().then((result) => {
        if (result.valid) {
          axios
            .post(
              Utility.constants().API.quickquote_study_submit,
              this.studyInsuranceSubmitTemplate
            )
            .then(() => {
              this.pushToTagManagerOnNext();
              this.index = 6;
            })
            .catch((err) => {
              if (!self.studyInsuranceSubmitTemplate.Zip) {
                self.studyInsuranceSubmitTemplate.Zip = '';
              }
              this.showModalError();
              Utility.logError(err.message, this);
              this.pushToTagManagerOnError(err.message);
            });
        } else {
          this.$refs.studyFlow.scrollToFirstError();
        }
      });
    },
    showModalError() {
      this.showStudyModal = true;
      this.showStudyModalError = true;
    },
    showModalContact() {
      this.showStudyModal = true;
      this.showStudyModalContact = true;
    },
    showModalStop() {
      this.showStudyModal = true;
      this.showStudyModalStop = true;
    },
    closeModal() {
      this.showStudyModal = false;
      this.showStudyModalError = false;
      this.showStudyModalContact = false;
      this.showStudyModalStop = false;
    },
    // For Tag Manager
    pushToTagManagerOnNext() {
      const stepIndexModel = this.getStepTitleAndDataForTagManager();
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: 'studie prisberegner',
        eventAction: '0' + this.index + ' ' + stepIndexModel.title + ' - submit ok',
        eventLabel: '',
        eventValue: '0',
        eventNoninteraction: true,
        data: stepIndexModel.data
      });
    },
    pushToTagManagerOnError(errorMsg) {
      const stepIndexModel = this.getStepTitleAndDataForTagManager();
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: 'studie prisberegner',
        eventAction: '0' + this.index + ' ' + stepIndexModel.title + ' - error',
        eventLabel: errorMsg,
        eventValue: '0',
        eventNoninteraction: true
      });
    },
    getStepTitleAndDataForTagManager() {
      var stepTitle;
      var stepData = {};
      switch (this.index) {
        case 1:
          stepTitle = 'oplysninger';
          stepData = {
            postnummer: this.studyInsuranceSubmitTemplate.Zip
          };
          break;
        case 2:
          stepTitle = 'personlige';
          break;
        case 3:
          stepTitle = 'supplerende';
          break;
        case 4:
          stepTitle = 'skader';
          break;
        case 5:
          stepTitle = 'betaling';
          break;
        case 6:
          stepTitle = '';
          break;
      }
      return {
        title: stepTitle,
        data: stepData
      };
    }
  }
};
</script>
<style>
.no-border-top {
  border-top: none;
}

#site-basket {
  border-bottom: 2px solid white;
}
</style>
